import Vue from 'vue';

const success = (context, type, index, response) => {
  if (type === 'theSpace') {
    context.theSpaceImages.splice(index, 1);
  } else if (type === 'slider') {
    context.sliderImages.splice(index, 1);
  } else {
    context.amenityImages.splice(index, 1);
  }

  toastr.success(response.msg);
};

const failed = (context, error) => {
    context.showToasterError(error);
};

export default (context, data, index) => {
  return Vue.$http.post('delete-img', data)
    .then(response => {
      if (response && response.status === 200) {
        success(context, data.type, index, response.data);
      }
    }).catch(error => {
      failed(context, error);
    })
}



// WEBPACK FOOTER //
// ./src/app/services/website/deleteImage.js